import { BusinessIDType, EntityType } from 'compliance-api/generated';
import { SelectOption } from 'ui';

export const entityTypeOptions: SelectOption<EntityType>[] = [
  { value: EntityType.ProprietaryLimited, label: 'Proprietary limited' },
  { value: EntityType.PublicCompany, label: 'Public company' },
  { value: EntityType.NoLiabilityCompany, label: 'No liability company' },
  { value: EntityType.SoleTrader, label: 'Sole trader' },
  { value: EntityType.Partnership, label: 'Partnership' },
  { value: EntityType.Trust, label: 'Trust' },
  { value: EntityType.Cooperative, label: 'Cooperative' },
  { value: EntityType.JointVenture, label: 'Joint venture' },
  { value: EntityType.IndigenousCorporation, label: 'Indigenous corporation' },
  { value: EntityType.Government, label: 'Government' },
  { value: EntityType.NonProfit, label: 'Non profit' },
];

export const businessNumberTypeOptions: SelectOption<BusinessIDType>[] = [
  { value: BusinessIDType.Abn, label: 'ABN' },
  { value: BusinessIDType.Acn, label: 'ACN' },
  { value: BusinessIDType.Tfn, label: 'TFN' },
  { value: BusinessIDType.Other, label: 'Other' },
];
